module.exports = __webpack_public_path__ + "img/integrito.d4f23789.svg";